import styled from 'styled-components';
import { colors } from '../../../../../../../../theme/colors';
import { Checkbox } from 'antd';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: ${colors.white};
  padding: 12px;
  border-radius: var(--4px, 8px);
  border: 1px solid #e7eaeb;
  gap: 10px;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  flex-direction: row-reverse;
  width: 100%;
  gap: 50px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 50%;
`;

const Title = styled.div`
  overflow: hidden;
  color: var(--Cool-Gray-700, #0a1e2c);
  text-overflow: ellipsis;
  font-family: 'Cera Pro Medium';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
`;

const DateLabel = styled.div`
  overflow: hidden;
  color: ${colors.gray[400]};
  text-overflow: ellipsis;
  font-family: 'Cera Pro';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 120% */
`;

const RowSection = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 120px;
  border-left: 2px solid #e7eaeb;
  padding-left: 12px;
  font-size: 12px;
`;

const ContentTitle = styled.div`
  overflow: hidden;
  color: var(--Cool-Gray-700, #0a1e2c);
  text-overflow: ellipsis;
  font-family: 'Cera Pro Medium';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
`;

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-left: 2px solid ${colors.primary[600]};
  padding-left: 6px;
  gap: 8px;
  height: 200px;
  color: black;
  width: 400px;
  overflow: auto;
`;

const CustomCheckbox = styled(Checkbox)<{ backgroundColor: string }>`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ backgroundColor }) => backgroundColor} !important;
    border-color: ${({ backgroundColor }) => backgroundColor} !important;
  }
`;

export default {
  Container,
  Content,
  Actions,
  Header,
  Title,
  DateLabel,
  RowSection,
  ContentTitle,
  TooltipContent,
  CustomCheckbox,
};
